import { Button } from "@chakra-ui/button";
import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
} from "@chakra-ui/form-control";
import { Input } from "@chakra-ui/input";
import { Textarea } from "@chakra-ui/textarea";
import React, { useState } from "react";
import { collection, addDoc } from "firebase/firestore";
import { firebaseDb } from "../../entry/firebase";
import { Box, Divider, Heading } from "@chakra-ui/layout";

function Support() {
  const [email, setEmail] = useState("");
  const [feedback, setFeedback] = useState("");
  const [sendStatus, setSendStatus] = useState("init");
  return (
    <Box maxW={"32rem"} style={{ padding: 40 }}>
      <Heading as="h1">AIO - the robot chef</Heading>
      <Divider />
      <Box pt={10}>
        <FormControl
          isRequired
          isInvalid={sendStatus === "failedValidate" && !email}
          pb={10}
        >
          <FormLabel htmlFor="email">Email address</FormLabel>
          <Input
            id="email"
            type="email"
            onChange={(e) => {
              setEmail(e.target.value);
              setSendStatus("init");
            }}
          />
          {(sendStatus !== "failedValidate" || email) && (
            <FormHelperText>We'll never share your email.</FormHelperText>
          )}
          {sendStatus === "failedValidate" && !email && (
            <FormErrorMessage>Email is required</FormErrorMessage>
          )}
        </FormControl>
        <FormControl
          isRequired
          isInvalid={sendStatus === "failedValidate" && !feedback}
          pb={10}
        >
          <FormLabel htmlFor="feedback">Your feedback</FormLabel>
          <Textarea
            id="feedback"
            disabled={sendStatus === "progress"}
            onChange={(e) => {
              setFeedback(e.target.value);
              setSendStatus("init");
            }}
          />
          {(sendStatus !== "failedValidate" || feedback) && (
            <FormHelperText>
              Please, add your feedback and email to keep in touch with updates.
            </FormHelperText>
          )}
          {sendStatus === "failedValidate" && !feedback && (
            <FormErrorMessage>Feedback is required</FormErrorMessage>
          )}
        </FormControl>
        {sendStatus === "progress" && <div>Sending...</div>}
        {sendStatus === "success" && <div>Successfully sent. Thank you for your feedback!</div>}
        {sendStatus === "error" && (
          <div>Sorry, something went wrong, try again later.</div>
        )}
        <Button
          onClick={async () => {
            try {
              if (!email || !feedback) {
                setSendStatus("failedValidate");
                return;
              }
              setSendStatus("progress");
              await addDoc(collection(firebaseDb, "feedback"), {
                email: email,
                feedback: feedback,
                sent: new Date().getTime(),
              });
              setSendStatus("success");
            } catch (e) {
              console.log(e);
              setSendStatus("error");
            }
          }}
        >
          Submit
        </Button>
      </Box>
    </Box>
  );
}

export default Support;
